import { SvgIcon, SvgIconProps } from '@mui/material';

const InCommandIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '28'}
    height={props.height || '32'}
    viewBox="0 0 28 32"
    fill="none"
    {...props}
  >
    <path
      d="M5.34775 17.3572H0V8.0027L13.8587 0L27.7229 8.0027V11.9284H25.0085V9.55999L19.4336 6.33728L13.8641 3.11997L2.71443 9.55999V14.6428H5.34235V17.3572H5.34775ZM22.3643 14.6428H27.7229V23.9973L13.8587 32L0 23.9973V20.0716H2.71443V22.44L13.8587 28.8746L25.0085 22.44V17.3572H22.3643V14.6428Z"
      fill="currentColor"
    />
    <path
      d="M22.3645 14.6424V11.0899L21.0073 10.3058L19.423 11.2197L18.2982 11.8685L13.8481 14.437L9.39794 11.8685L6.69433 10.3058L5.33171 11.0899V14.6424V17.3569V20.9148L12.4909 25.0459V21.9206L8.04614 19.3521V14.2153L13.8481 17.5623L19.6501 14.2153V19.3521L15.2053 21.9206V25.0459L22.3645 20.9148V17.3569V14.6424Z"
      fill="#00B2A9"
    />
    <path
      d="M9.39757 8.74323L12.1012 10.3059L13.8477 9.29477L15.5997 10.3059L18.2979 8.74323L14.5236 6.56411L13.8477 6.17479L9.39757 8.74323Z"
      fill="#00B2A9"
    />
  </SvgIcon>
);

export default InCommandIcon;
